export default {
    // 日语
    LOCALE_HTML: {
        'msg.language': 'ja',
        'msg.title': 'タイトル',
        'msg.type': '問題分類',
        'msg.des': '問題説明',
        'msg.phone': '携帯番号',
        'msg.regionCode': '市外局番',
        'msg.email': 'メールアドレス',
        'msg.choose': '分類を選んでください',
        'msg.detail': 'メッセージ子細',
        'msg.back': '戻る',
        'your.msg': 'メッセージ置く',
        'msg.record': 'メッセージ記録',
        'msg.success': 'メッセージを置くことが成功です。',
        'to.record': 'メッセージ記録へ',
        completed: '完成',
        submit: '提出',
        'success.desc': 'メッセージ提出成功です。ありがとうございます。',
        'msg.form.input': '入力してください。',
        'msg.reply': '返事',
        'comment.suc': '評価を頂いて、ありがとうございます。',
        'comment.fail': '提出失敗',
        'comment.placeholder':
            'サービスに対して、アドバイスを頂くのは歓迎です。',
        'reply.suc': '提出成功です。',
        'reply.fail': '返事内容を入力してください。',
        'reply.placeholder': '返事内容を入力してください。',
        'msg.more': '内容をもとチェックする',
        'msg.collapse': 'アンフォウトイ',
        'msg.myservice': '私のサービス評価',
        'msg.evaluate': 'サービス評価',
        'msg.evaluateTitle': 'サービス評価',
        'msg.score': '評点',
        'msg.remark': '評語',
        'msg.status.created': '創建済み',
        'msg.status.pending': '受理待つ',
        'msg.status.processing': '受理中',
        'msg.status.solved': '完成',
        'msg.service.reply': 'オペレーターの返事',
        'msg.my.reply': 'お返事',
        'msg.toast.des': '問題説明は空白',
        'msg.toast.type': '問題分類は空白',
        'msg.toast.title': 'タイトルは空白',
        'msg.toast.none': '空白しないでください。',
        'msg.toast.noAnnex': '添付ファイルをアップロードしてください。',
        'msg.toast.noEmail': 'メールアドレスを空白しないでください。',
        'msg.toast.noTel': '携帯番号を空白しないでください。',
        'msg.toast.noRegionCode': '市外局番は空欄にできません',
        'msg.toast.noZone': 'タイムゾーンを選択してください',
        'msg.toast.noDateTime': '日付時間を選択してください',
        'msg.toast.email': '正しいメールアドレスを入力してください。',
        'msg.toast.tel': '正しい携帯番号を入力してください。',
        'msg.toast.regionCode': '市外局番を選択してください',
        'msg.toast.num': '正しい数字を入力してください。',
        'msg.toast.annex': '添付ファイルをアップロードしてください。',
        'msg.toast.char': '正しい文字を入力してください。',
        'msg.list.none': 'データ無し',
        'msg.form.choose': '選んでください',
        'msg.form.chooseZone': 'タイムゾーンを選択してください',
        'msg.form.chooseTime': '時間を選択',
        'msg.form.chooseDate': '日付を選択',
        'msg.form.sure': '確定',
        'msg.form.search': '捜索．．．',
        'msg.form.uploadError': '様式間違い',
        'msg.form.uploadXss':
            'アップロードに失敗しました。ファイル コンテンツに不正なスクリプトが含まれています',
        'msg.update.time': 'に更新されました',
        'msg.replace.images': '写真',

        MSG016: '解決した',
        MSG017: '未解決',
        MSG019: '送信',
        MSG072: '評価ラベルを空にすることはできません! ',
        MSG073: '評価言語を空にすることはできません! ',
        MSG074: 'ラベル：',
        MSG075: '解決されましたか:',
        MSG076: '問題が解決したかどうかを選択してください',
        MSG015: 'このチケットで問題は解決しましたか?',

        'file.size.limit': 'ファイルの大きさは50㎆に超えてはいけません。',
        'detail.file.limit': '最大限は15個、大きさは50Mに超えないように。',
        'form.question.des.tip': '問題説明を入力してください。',
        'form.title.tip': 'タイトルを入力してください。',
        'form.class.tip': '問題分類を選んでください。',
        'upload.file': '添付ファイルをアップロード',
        'file.count.limit': 'アップロードできる最大限は15個',
        'select.search.placeholder': 'キーワードを捜索',
        'msg.form.sizeError1':
            '5M以下の添付ファイルをアップロードしてください。',
        'msg.form.sizeError2':
            '50M以下の添付ファイルをアップロードしてください。',
        'msg.form.submit': '提出中．．．',
        'msg.form.upload': 'アップロード中．．．',
        'msg.email.tip1': 'ごメッセージを検索できないでした。',
        'msg.email.tip2':
            '以前メッセージを残した場合は、メール検証でチェックできます。',
        'msg.email.tip3': 'メール検証を始めます。',
        'msg.email.noData': 'このアカウントはデータ無しです。',
        'email.verify.tip': 'メッセージを置く時に使ったメールアドレスを入力',
        'email.input.placeholder': 'メールアドレスを入力してください。',
        'email.submit': 'メール発信',
        'email.rules.error': '正しいメールアドレスを入力してください。',
        'email.code.tip':
            'メール発信済みです。受けた検証コードを入力してください。',
        'email.code.placeholder': '検証コードを入力してください。',
        'email.code.submit': 'すぐにチェックする',
        'email.notFind.customer':
            'カスタマーインフォメーションを検索できません。',
        'email.code.wrong': '検証コードは間違いました。再入力をしてください。',
        'email.code.expired':
            '検証コードの期限は切れました。もう一度メール検証をしてください。',
        'email.code': '検証コード',
        'email.send.frequently':
            'あまりにも頻繫の操作をしてから、後でもう一度試してください。',
        'comment.fail.400133': 'このチケットは評価されました',
        'not.get.user.info': '情報を取得できませんでした',
        'user.verify.tip':
            'メッセージリストの内容を確認するには、検証を通過する必要があります',
        'verify.type.email': 'メールボックスの検証',
        'verify.text': '検証',
        'cancel.text': 'キャンセル',
        'get.verify.code': '認証コードの取得',
        'reGet.verify.code': '再取得 ',
        'verify.by.email.tip':
            '認証コードは、入力したメールアドレスにメールで送信されます',
        'verify.type.phone': 'ショートメッセージの検証',
        'phone.placeholder': '携帯番号を入力してください',
        'verify.by.phone.tip':
            '認証コードは、入力した携帯電話番号にメールで送信されます',
        'phone.error': '携帯番号を入力してください',
        'phone.errorCode400150': '認証コードの送信頻度',
        'phone.errorCode400233':
            'メッセージテンプレートを空にすることはできません',
        'phone.errorCode400234': 'マーケティングメールの残高が不足している',
        'phone.errorCode400235': 'SMS残高不足の通知',
        'phone.errorCode400247':
            '製造オーダプラグインのショートメッセージ設定エラー',
        'phone.errorCode4400248': 'メッセージテンプレートの取得に失敗しました',
        'phone.errorCode400249':
            'この番号は既存のユーザーの携帯番号ではありません',
        'phone.errorCode400250':
            '認証コードが期限切れになっているので、再取得してください',
        'msg.you.reply': '返信が届きました',
        'msg.no.reply':'返事なし',
    },
    LOCALE_REQUEST: {
        400016: '作業指示書情報の取得の有効期限が切れています。更新してください。'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: '削除',
                cancel: 'キャンセル',
                confirm: '決定',
                inert: '挿入',
                width: '幅',
                height: '高さ'
            },
            controls: {
                clear: 'クリアコンテンツ',
                undo: 'キャンセル',
                redo: 'キャンセル',
                fontSize: 'フォントサイズ',
                lineHeight: 'フォントサイズ',
                letterSpacing: 'ワード間隔',
                textIndent: '段落のインデント',
                increaseIndent: 'インデントを増やす',
                decreaseIndent: 'インデントを減らす',
                border: '国境',
                color: '色',
                textColor: 'テキストの色',
                backgroundColor: '背景色',
                tempColors: '仮色',
                bold: '太字',
                italic: 'イタリック体',
                underline: '下線',
                strikeThrough: '取り消し線',
                fontFamily: 'フォント',
                textAlign: 'テキストの配置',
                alignLeft: '左',
                alignCenter: '中央揃え',
                alignRight: '右に立つ',
                alignJustify: '両端',
                floatLeft: '左フローティング',
                floatRight: '右フローティング',
                superScript: '上付き',
                subScript: '下付き文字',
                removeStyles: 'クリアスタイル',
                headings: '役職',
                header: '役職',
                normal: '従来の',
                orderedList: '順序付きリスト',
                unorderedList: '番号なしリスト',
                blockQuote: '参照',
                code: 'コード',
                link: 'リンク',
                unlink: 'リンクを解除',
                hr: '横線',
                media: 'メディア',
                mediaLibirary: 'メディアライブラリー',
                emoji: '小さな表現',
                fullscreen: '全画面',
                exitFullscreen: '全画面を退く'
            },
            linkEditor: {
                textInputPlaceHolder: 'リンクテキストを入力',
                linkInputPlaceHolder: 'リンクアドレスを入力',
                inputWithEnterPlaceHolder: 'リンクアドレスを入力して戻ります',
                openInNewWindow: '新しいウィンドウで開く',
                removeLink: '新しいウィンドウで開く'
            },
            audioPlayer: {
                title: 'オーディオファイルを再生する'
            },
            videoPlayer: {
                title: 'ビデオファイルを再生する',
                embedTitle: '埋め込みメディア'
            },
            media: {
                image: '画像',
                video: 'ビデオ',
                audio: '音声',
                embed: '埋め込みメディア'
            }
        },
        finder: {
            remove: '削除する',
            cancel: 'キャンセル',
            confirm: '確認する',
            insert: '選択したアイテムを挿入',
            width: '幅',
            height: '身長',
            image: '絵',
            video: 'ビデオ',
            audio: '音声',
            embed: '埋め込みメディア',
            caption: 'メディアライブラリー',
            dragTip: 'ファイルをこの位置までクリックまたはドラッグします',
            dropTip: 'アップロードするマウスを放します',
            selectAll: 'すべて選択',
            deselect: '選択を解除',
            removeSelected: '選択したアイテムを削除',
            externalInputPlaceHolder: 'リソース名|リソースアドレス',
            externalInputTip:
                'リソース名とリソースアドレスは "|"で区切ります。',
            addLocalFile: 'ローカルリソースを追加する',
            addExternalSource: 'ネットワークリソースを追加する',
            unnamedItem: '名前のないアイテム',
            confirmInsert: '選択したアイテムを挿入'
        }
    }
}
